module.exports = __webpack_public_path__ + "images/icons/psp/portable-storage/portable-military-families.svg";